/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stock_Out_Lot_No_PositionInputs */

const vi_stock_out_lot_no_position = /** @type {(inputs: Stock_Out_Lot_No_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa gán vị trí`)
};

/**

* @param {Stock_Out_Lot_No_PositionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stock_out_lot_no_position = /** @type {((inputs?: Stock_Out_Lot_No_PositionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Out_Lot_No_PositionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stock_out_lot_no_position(inputs)
});